import { z } from "zod";
const serialized = z.object({
  type: z.string()
}).and(z.record(z.string(), z.unknown()));
const serializedRecord = serialized.brand();
const deserializedRecord = serialized.brand();
export {
  deserializedRecord,
  serialized,
  serializedRecord
};
//# sourceMappingURL=schema.js.map